module.exports = __webpack_public_path__ + "static/media/1BIANCA_Official_MENU-20530.90694cd3.jpg";